
const CountryItem = ({country}) => {

    return (
        <option value={country}>{`${country}`}</option>
    )
}

export default CountryItem;
